(ns manage.adset-decision-tree-page.navigation
  (:require [reitit.frontend.easy :as rfe]))

(defn change-view-mode [mode]
  (rfe/set-query (fn [query-params]
                   (assoc query-params :view-mode mode))))

(defn enter-editor-mode []
  (change-view-mode "editor"))

(defn exit-to-table []
  (change-view-mode "table"))

(defn change-selection [{:keys [immutable-node-id default-outcome view-mode]}]
  (rfe/set-query (fn [query-params]
                   (cond-> query-params
                     true (assoc :immutable-node-id immutable-node-id)
                     view-mode (assoc :view-mode view-mode)
                     default-outcome (assoc :default-outcome default-outcome)
                     (not default-outcome) (dissoc :default-outcome)))))
